import styled from 'styled-components';
import { toRem, theme } from '@marriott/mi-ui-library-shop';

export const StyledShopPageDatesHeaderDiv = styled.div<{ isADFPage?: boolean; dateLength?: number }>(
  ({ isADFPage, dateLength }) => `
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 0 ${isADFPage ? toRem(0) : dateLength && dateLength >= 16 ? toRem(5) : toRem(32)};
  @media ${theme.mediaQuery.allTablets} {
    padding: 0 ${dateLength && dateLength >= 16 ? toRem(5) : toRem(20)};
    width: 100%;
    padding-left: ${isADFPage ? toRem(0) : dateLength && dateLength >= 16 ? toRem(5) : toRem(20)};
  }
  @media ${theme.mediaQuery.allMobiles} {
    padding-left: 0;
  }
`
);

export const StyledShopPageDateBoxDiv = styled.div<{
  focused: boolean;
  isCNLocale: boolean;
  currentLocale: string;
  dateLength?: number;
}>(
  ({ focused, isCNLocale, currentLocale, dateLength }) => `
    width: ${isCNLocale ? toRem(212) : toRem(196)};
    position: relative;
    margin-right: ${toRem(79)};
    .t-subtitle-s {
      font-size : 9pt;
      line-height : 20pt ;
      font-weight: 600 ;
    }
    .horizantal-line {
      border-bottom: ${toRem(3)} solid ${theme.color['cod-grey']} ;
    position: absolute;
    width: inherit;
    @media ${theme.mediaQuery.minDesktop} {
      top: 141%;
      z-index:1;
    }
     @media ${theme.mediaQuery.allTablets} {
      top: 136%;
      width:100%;
      z-index:1;
    }
    @media ${theme.mediaQuery.allMobiles}{
      display:none;
    }
    }
    @media ${theme.mediaQuery.allTablets} {
      min-width:${toRem(120)};
      margin-right: ${toRem(20)};
      width:auto;
    }
     @media ${theme.mediaQuery.smallerTablet} {
      min-width:${toRem(120)};
      margin-right: ${toRem(20)};
      &:nth-child(2) {
        min-width:${toRem(140)};
      }
    }
     @media ${theme.mediaQuery.allMobiles} {
      margin-right: ${toRem(20)};
      min-width:${toRem(145)};
    }
    @media ${theme.mediaQuery.minDesktop} {
      &:hover{
        opacity: 0.6;
      }
    }
    &:nth-child(2) {
        padding-left: ${dateLength && dateLength >= 16 ? toRem(5) : toRem(10)};
        border-left: ${toRem(1)} dashed ${theme.color['dark-gray-6']};
        margin-right:0;
        @media ${theme.mediaQuery.allMobiles} {
          padding-left:0;
          border-left:0;
        }
        @media ${theme.mediaQuery.desktop} {
            padding-left: ${dateLength && dateLength >= 16 ? toRem(5) : toRem(32)};
            width: ${dateLength && dateLength >= 16 ? toRem(186) : toRem(213)};
        }
        @media ${theme.mediaQuery.largeDesktop} {
            padding-left: ${dateLength && dateLength >= 16 ? toRem(8) : toRem(48)};
            width: ${dateLength && dateLength >= 16 ? toRem(189) : toRem(229)};
        }
    }
    
    button {
        outline: none;
        cursor: pointer;
        background: transparent;
        padding: 0;
        width:100%;
        border: none;
       
        @media ${theme.mediaQuery.allTablets}{
          .icon-nav---book {
              text-wrap :${currentLocale === 'nb-NO' || currentLocale === 'sv-SE' ? 'nowrap' : ''};
          }
          .search-page-date-text  {
              font-size:${currentLocale === 'nb-NO' || currentLocale === 'sv-SE' ? toRem(14) : toRem(16)};
          }
        }

        @media ${theme.mediaQuery.allMobiles} {
          .calendar-text-ellipsis {
            text-overflow: ellipsis;
            overflow:hidden;
            white-space:nowrap;
            width:100%;
          }
          padding-bottom: ${toRem(13)};
          opacity: ${focused ? '1' : '0.8'};
          border-bottom: ${toRem(1)} solid ${theme.color.white};
          &:after {
              content: "";
              border-bottom:${toRem(4)} solid ${focused ? `${theme.color.white}` : 'transparent'};
              width: 100%;
              position: absolute;
              right: 0;
              bottom: 0;
            }
          .t-label-xs {
            color:${theme.color.white};
          }
        }
        &:first-child {
          display: flex;
          flex-direction: column;
          white-space: nowrap;
          @media ${theme.mediaQuery.tabletMax} {
            white-space: ${dateLength && dateLength >= 16 ? 'normal' : 'nowrap'};
        }
          text-align: left;
          text-overflow: ellipsis;
          overflow: ${dateLength && dateLength >= 16 ? 'visible' : 'hidden'};
          width: 100%;
            span {
              &:first-child {
                  padding-bottom: ${toRem(6)};
                  text-transform: uppercase;
                  @media ${theme.mediaQuery.desktop} {
                      padding-bottom: ${toRem(4)};
                  }
                }
            }
        }
        &:nth-child(2){
            font-size: ${toRem(24)};
            line-height: ${toRem(20)};
            position: absolute;
            bottom: ${toRem(19)};
            right: 0;
            padding: 0;
            ::before {
                color: ${theme.color['base-10']};
            }
        }

    }
`
);
